import { useEffect, lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { WcagWidget } from "@/components/WcagWidget";
import { StickyCta } from "@/components/StickyCta";
import Home from "@/pages/Home";

const About = lazy(() => import("@/pages/About"));
const Partner = lazy(() => import("@/pages/Partner"));
const Join = lazy(() => import("@/pages/Join"));
const Companies = lazy(() => import("@/pages/Companies"));
const Contact = lazy(() => import("@/pages/Contact"));
const Accessibility = lazy(() => import("@/pages/Accessibility"));
const Admin = lazy(() => import("@/pages/Admin"));

let lenisInstance = null;

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (lenisInstance) {
      lenisInstance.scrollTo(0, { immediate: true });
    }
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ smoothWheel: true });
    lenisInstance = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-white text-navy">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Suspense fallback={<div className="min-h-[60vh]" />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/partner" element={<Partner />} />
              <Route path="/join" element={<Join />} />
              <Route path="/companies" element={<Companies />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/accessibility" element={<Accessibility />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
        <WcagWidget />
        <StickyCta />
        <Toaster position="bottom-right" theme="dark" />
      </BrowserRouter>
    </div>
  );
}
